export interface TeacherThroughUser {
  // TODO: add missing properties (check newsela/people/rest_api/v2/views/teacher.py#TeacherThroughUserView.get)
  _editable: Editable;
  id: number;
  pk: number;
  unique_id: string;
  user_id: number;
  user_pk: number;
  user_unique_id: string;
  school: number;
  school_id: number;
  school_pk: number;
  school_unique_id: string;
  role: string;
  secondary_role: string | null;
  technology: string | null;
  reading_standards: string;
  lowest_preferred_grade_level: GradeLevel;
  highest_preferred_grade_level: GradeLevel;
  classroom_grades: GradeLevel[];
  subjects_by_source: SubjectsBySource;
  external_id: number | null;
}

export interface Editable {
  school: boolean;
  highest_preferred_grade_level: boolean;
  lowest_preferred_grade_level: boolean;
  external_id: boolean;
  role: boolean;
  secondary_role: boolean;
  technology: boolean;
}

export interface SubjectsBySource {
  classroom_subjects: Subject[];
  teacher_subjects: Subject[];
}

export type GradeLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type Subject =
  | "English/Language Arts/Reading"
  | "English Language Learners"
  | "Foreign Language"
  | "General Elementary"
  | "Math"
  | "Science"
  | "Social Studies/Social Science"
  | "Special Education"
  | "Other";

export const teacherThroughUserMock: TeacherThroughUser = {
  _editable: {
    school: true,
    highest_preferred_grade_level: true,
    lowest_preferred_grade_level: true,
    external_id: true,
    role: true,
    secondary_role: true,
    technology: true,
  },
  id: 2005446126,
  pk: 2005446126,
  unique_id: "157b74a49166467bb6cda9ecf8812164",
  user_id: 2054574170,
  user_pk: 2054574170,
  user_unique_id: "157b74a49166467bb6cda9ecf8812164",
  school: 2000296911,
  school_id: 2000296911,
  school_pk: 2000296911,
  school_unique_id: "ce279f813f414b788baee36697d6a052",
  role: "teacher",
  secondary_role: null,
  technology: null,
  reading_standards: "cc",
  lowest_preferred_grade_level: 1,
  highest_preferred_grade_level: 2,
  classroom_grades: [9],
  subjects_by_source: {
    classroom_subjects: [],
    teacher_subjects: ["English Language Learners"],
  },
  external_id: null,
};
